import { portalApi } from '../../../api';

const initialState = {
  jobs: {
    fetched: false,
    data: [],
    pageInfo: {
      stats: []
    }
  }
};

const CLEAR_DEPARTMENT = 'CLEAR_DEPARTMENT';
export const clearDepartment = () => dispatch => dispatch({ type: CLEAR_DEPARTMENT });

const GET_DEPARTMENT_JOBS = 'GET_DEPARTMENT_JOBS';
const GET_DEPARTMENT_JOBS_SUCCESS = 'GET_DEPARTMENT_JOBS_SUCCESS';
const GET_DEPARTMENT_JOBS_FAILURE = 'GET_DEPARTMENT_JOBS_FAILURE';
export const getDepartmentJobs = departmentId => async dispatch => {
  dispatch({ type: GET_DEPARTMENT_JOBS, departmentId });

  try {
    const { data, ...pageInfo } = await portalApi.getDepartmentJobs(departmentId);
    dispatch({ type: GET_DEPARTMENT_JOBS_SUCCESS, data, pageInfo });
  } catch (error) {
    dispatch({ type: GET_DEPARTMENT_JOBS_FAILURE, error });
  }
};

const GET_DEPARTMENT_JOBS_WITH_STATS = 'GET_DEPARTMENT_JOBS_WITH_STATS';
const GET_DEPARTMENT_JOBS_WITH_STATS_SUCCESS = 'GET_DEPARTMENT_JOBS_WITH_STATS_SUCCESS';
const GET_DEPARTMENT_JOBS_WITH_STATS_FAILURE = 'GET_DEPARTMENT_JOBS_WITH_STATS_FAILURE';

export const getDepartmentJobsWithStats = departmentId => async dispatch => {
  dispatch({ type: GET_DEPARTMENT_JOBS_WITH_STATS, departmentId });

  try {
    const { data, ...pageInfo } = await portalApi.getDepartmentJobsWithStats(departmentId);
    dispatch({ type: GET_DEPARTMENT_JOBS_WITH_STATS_SUCCESS, data, pageInfo });
  } catch (error) {
    dispatch({ type: GET_DEPARTMENT_JOBS_WITH_STATS_FAILURE, error });
  }
};

const departmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DEPARTMENT_JOBS_WITH_STATS_SUCCESS:
    case GET_DEPARTMENT_JOBS_SUCCESS:
      return {
        ...state,
        jobs: {
          fetched: true,
          data: action.data,
          pageInfo: action.pageInfo
        }
      };
    case GET_DEPARTMENT_JOBS_WITH_STATS_FAILURE:
    case GET_DEPARTMENT_JOBS_FAILURE:
      return { ...state, error: action.error };
    case CLEAR_DEPARTMENT:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export const selectDepartmentJobs = state => state.department.jobs.fetched && state.department.jobs.data;

export default departmentReducer;
